<template>
  <div class="ai-trade-list">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入用户id"
        v-model="params.uid"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入id"
        v-model="params.id"
        clearable
        size="small"
        class="param-input"
        style="width: 280px"
      ></el-input>
      <el-input
        placeholder="请输入AI模版id"
        v-model="params.mId"
        clearable
        size="small"
        class="param-input"
        style="width: 280px"
      ></el-input>
      <el-select
        v-model="params.status"
        placeholder="请选择状态"
        clearable
        size="small"
        style="width: 180px"
      >
        <el-option
          v-for="item in statuses"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" fixed width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ initTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="模版图" align="center" min-width="120">
        <template slot-scope="scope">
          <img-load
            :width="'70px'"
            :height="'70px'"
            :src="imgUrl + scope.row.modPic"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column label="原始图" align="center" min-width="120">
        <template slot-scope="scope">
          <img-load
            :width="'70px'"
            :height="'70px'"
            :src="imgUrl + scope.row.originPic"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column
        label="AI换脸图"
        align="center"
        min-width="120"
        prop="newPic"
      >
        <template slot-scope="scope">
          <img-load
            :width="'70px'"
            :height="'70px'"
            :src="imgUrl + scope.row.newPic"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status === 1">进行中</el-tag>
          <el-tag type="success" v-if="scope.row.status === 2">生成成功</el-tag>
          <el-tag type="danger" v-if="scope.row.status === 3">生成失败</el-tag>
          <el-tag type="info" v-if="scope.row.status === 5">已经提交</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="coin" label="金币" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.coin }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="mId" label="模版ID" align="center" width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.mId || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateAct"
        label="操作者"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updateAct || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.remark || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ initTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="pass(scope.row)"
            v-if="scope.row.status == 1"
            >通过</el-button
          >
          <!-- <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="openEdit(scope.row, 'pass')"
            v-if="scope.row.status == 1"
            >通过</el-button
          > -->
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-edit"
            @click="openEdit(scope.row, 'reject')"
            v-if="scope.row.status == 1"
            >拒绝</el-button
          >
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-refresh"
            v-if="scope.row.status == 2 || scope.row.status == 5"
            @click="openReset(scope.row)"
            >状态重置</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--封面图、视频弹窗组件-->
    <preview-video ref="previewVideo"></preview-video>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 打开窗口 -->
    <el-dialog
      title="编辑"
      :visible.sync="editVisible"
      width="500px"
      @before-close="handleClose()"
      @close="handleClose()"
    >
      <el-form>
        <div class="form_item">
          <el-form-item label="AI图:" prop="newPic" v-if="optType == 'pass'">
            <base-upload
              :cover="form.newPic"
              :action="action"
              @successCallback="successCallback"
              :hide="true"
            ></base-upload>
          </el-form-item>
          <el-form-item label="拒绝原因" prop="remark" v-else>
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              class="inp"
              v-model="form.remark"
            ></el-input>
          </el-form-item>
          <el-form-item label="原始图:" prop="background">
            <img-load
              :width="'148px'"
              :height="'148px'"
              :src="imgUrl + originPic"
            ></img-load>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";
import PreviewVideo from "./../../videoManagement/videoExamine/components/preview-video";

export default {
  components: {
    PreviewVideo,
  },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      statuses: [
        { label: "进行中", value: 1 },
        { label: "生成成功", value: 2 },
        { label: "生成失败", value: 3 },
        { label: "已提交", value: 5 },
      ],
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        status: undefined,
        id: undefined,
        uid: undefined,
        mId: undefined,
      },
      editVisible: false,
      form: {
        id: "",
        newPic: undefined,
        status: undefined,
        remark: undefined,
      },
      originPic: undefined,
      optType: "",
      // 用户头像上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 请求列表
    getList(type) {
      this.loading = false;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getAiImgTransList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 上传成功回掉
    successCallback(res) {
      this.form.newPic = [res.data.coverImg];
    },
    pass(row) {
      const req = {
        id: row.id,
        title: row.moduleTitle,
        status: 5,
      };
      API.aiImgTransExamine(req).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "通过成功",
          });
          this.handleClose();
          this.getList();
        } else {
          this.$message({
            type: "error",
            message: res.msg || "通过失败",
          });
        }
      });
    },
    // 打开编辑
    openEdit(param, type) {
      this.optType = type;
      this.form.id = param.id;
      this.originPic = param.originPic;
      if (type == "pass") {
        this.form.status = 2;
      } else {
        this.form.status = 3;
      }
      this.editVisible = true;
    },
    onSubmit() {
      if (!this.form.newPic && this.optType == "pass")
        return this.$message.warning("请上传AI图片");
      if (!this.form.remark && this.optType == "reject")
        return this.$message.warning("请填写拒绝原因");
      API.aiImgTransExamine(this.form).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: this.optType == "pass" ? "通过成功" : "拒绝成功!",
          });
        } else {
          this.$message({
            type: "error",
            message:
              res.tip || this.optType == "pass" ? "通过失败" : "拒绝失败",
          });
        }
        this.handleClose();
        this.getList();
      });
    },
    openReset(row) {
      this.$confirm("确认重置该订单吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let req = {
            id: row.id,
            status: 1,
          };
          API.aiImgTransExamine(req).then((res) => {
            if (res.code == 200) {
              this.getList();
              this.$message({
                type: "success",
                message: "重置成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: res.msg || "重置失败!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置",
          });
        });
    },
    handleClose() {
      this.editVisible = false;
      this.form.id = "";
      this.form.newPic = undefined;
      this.form.status = undefined;
      this.form.remark = undefined;
      this.originPic = undefined;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    initTime(time) {
      return uniteDate(time);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.form_item {
  display: flex;
}
.clickNumDialog {
  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
  /deep/ .el-pagination {
    float: none;
    text-align: right;
    margin-top: 30px;
  }
}
/deep/ .el-input {
  width: 80%;
}
/deep/ .el-form-item {
  width: 100%;
}
</style>
